import { styled, View } from "@tamagui/core";
import { Button } from "../Button/Button.mjs";
import { GroupContext } from "./Group.context";
import { jsx } from "react/jsx-runtime";
const GroupButtonContainer = styled(View, {
    alignItems: "center",
    context: GroupContext,
    justifyContent: "center",
    variants: {
      layout: {
        column: {
          width: "100%"
        },
        row: {
          width: "auto"
        }
      }
    }
  }),
  GroupButton = props => /* @__PURE__ */jsx(GroupButtonContainer, {
    children: /* @__PURE__ */jsx(Button, {
      ...props,
      alignSelf: props.variant === "tertiary" ? "center" : void 0
    })
  });
GroupButton.displayName = "Group.Button";
export { GroupButton, GroupButtonContainer };
//# sourceMappingURL=Group.Button.mjs.map
